import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';

import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Button, Input, Form, Checkbox } from 'components/common';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig, loginRequest } from '../../authConfig.js';
import MicrosoftLoginButton from './MicrosoftLoginButton.js';

const CredentialsForm = ({
  form,
  isLoading,
  handleLogin,
  handleChange,
  handleReset,
  handleExternalLogin,
  onContinueToSso,
}) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);

  const msalInstance = new PublicClientApplication(msalConfig);

  const handleLoginPopup = () => {
    /**
     * For more information, please follow this link: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/login-user.md#redirecturi-considerations
     */
    msalInstance
      .loginPopup({
        ...loginRequest,
        redirectUri: '/',
      })
      .then(authResponse => {
        handleExternalLogin('MICROSOFT', authResponse.idToken);
      })
      .catch(error => console.log(error));
  };

  const noDetails = !form.username || !form.password;
  return (
    <>
      <MsalProvider instance={msalInstance}>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_PORTAL_GOOGLE_AUDIENCE}
        >
          <Form onSubmit={handleLogin}>
            <div>
              <div className='label'>Email</div>
              <Input
                disabled={isLoading}
                ref={ref}
                onChange={handleChange('username')}
                value={form.username}
                placeholder='Enter Email Address'
              />
            </div>
            <div>
              <div className='label'>Password</div>
              <Input
                disabled={isLoading}
                onChange={handleChange('password')}
                value={form.password}
                placeholder='Enter Password '
                password
              />
            </div>
            <Checkbox
              disabled={isLoading}
              checked={form.rememberMe}
              onChange={handleChange('rememberMe')}
              labelText='Remember me'
            />
          </Form>
          <Button
            disabled={isLoading || noDetails}
            onClick={handleLogin}
            type='primary'
          >
            Log In
          </Button>
          <Button
            type='link'
            disabled={isLoading}
            onClick={handleReset}
            className='forgot-password'
          >
            Forgot Password?
          </Button>
          <Button
            type='link'
            disabled={isLoading}
            onClick={() => onContinueToSso && onContinueToSso(form.username)}
            className='continue-to-sso'
          >
            Continue to SSO
          </Button>
          <div className='or'>or</div>
          <GoogleLogin
            disabled={isLoading}
            ux_mode={'popup'}
            auto_select={false}
            useOneTap={false}
            width='395'
            onSuccess={credentialResponse => {
              handleExternalLogin('GOOGLE', credentialResponse.credential);
            }}
          />
          <MicrosoftLoginButton
            disabled={isLoading}
            onClick={handleLoginPopup}
          />
        </GoogleOAuthProvider>
      </MsalProvider>
    </>
  );
};

CredentialsForm.propTypes = {
  form: PropTypes.shape({
    username: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  isLoading: PropTypes.bool,
  handleLogin: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  onContinueToSso: PropTypes.func,
};

CredentialsForm.defaultProps = {
  isLoading: false,
  onContinueToSso: null,
};

export default CredentialsForm;
